var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header", { ref: "child" }),
      _vm._v(" "),
      _c("Navigation", { attrs: { page: _vm.page } }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page === 1,
              expression: "page === 1"
            }
          ],
          staticClass: "page-three page-style"
        },
        [
          _c("InputHousehold", {
            on: {
              "handle-change-household": _vm.changehouseHold,
              "handle-change-familylivingtogether":
                _vm.changeFamilyLivingTogether
            }
          }),
          _vm._v(" "),
          _c("NursingPage", {
            on: {
              "handle-change-care-certification": _vm.changeCareCertification,
              "handle-change-care-insurance": _vm.changeCareInsurance
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page === 2,
              expression: "page === 2"
            }
          ],
          staticClass: "page-four page-style"
        },
        [
          _c("NursingPage2", {
            on: {
              "handle-change-medical-insurance": _vm.changeMedicalInsurance,
              "handle-change-handicapped-notebook":
                _vm.changeHandicappedNotebook,
              "handle-change-rehabilitation-notebook":
                _vm.changeRehabilitationNotebook,
              "handle-change-mental-notebook": _vm.changeMentalNotebook
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page === 3,
              expression: "page === 3"
            }
          ],
          staticClass: "page-four page-style"
        },
        [
          _c("NursingPage3", {
            on: {
              "handle-change-beneficiary-certificate":
                _vm.changeBeneficiaryCertificate,
              "handle-change-medical-history": _vm.changeMedicalHistory
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page === 4,
              expression: "page === 4"
            }
          ],
          staticClass: "page-five"
        },
        [
          _c("SelectIllustrationPage", {
            on: { "handle-change-avatar-id": _vm.changeAvatarId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _vm.page > 1
          ? _c("img", {
              attrs: { src: require("@/assets/sign_up/アセット 4@2x.png") },
              on: { click: _vm.prev }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 1 && this.accountCreate.household_composition === false
          ? _c("img", {
              staticClass: "inactive_img",
              attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
            })
          : _vm.page === 1 &&
            this.accountCreate.household_composition === "1" &&
            this.accountCreate.housemate.length === 0
          ? _c("img", {
              staticClass: "inactive_img",
              attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") }
            })
          : _vm.page < 4
          ? _c("img", {
              attrs: { src: require("@/assets/sign_up/アセット 3@2x.png") },
              on: { click: _vm.next }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.page === 4 && this.accountCreate.avatar_id === ""
          ? _c("img", {
              staticClass: "inactive_img",
              attrs: { src: require("@/assets/sign_up/アセット 55@2x.png") }
            })
          : _vm.page === 4
          ? _c("img", {
              attrs: { src: require("@/assets/sign_up/アセット 55@2x.png") },
              on: { click: _vm.complete }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showContent,
            expression: "showContent"
          }
        ],
        on: { pushedCancel: _vm.hideContent, "handle-submit": _vm.submit }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c79c915", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c79c915","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AccountCreate.vue
// module id = null
// module chunks = 